interface PageMainTitle {
  category: string
  title: string
  sub_title: string
  sub_title2: string
  text: string
}

export const pageMainTitle: PageMainTitle = {
  category: '事例',
  title: 'Case study',
  sub_title: '',
  sub_title2: '',
  text: 'Aitriaのプロジェクト事例をまとめました。Digital Innovatorとして、クラウドネイティブ、AI駆動開発、デザインシステムに精通した様々な支援実績がございます。',
}
